import { CLICK_SIGN_BUTTON, SEND, GET_LOGIN, GET_PASSWORD } from './actionConst';
import axios from 'axios';

const clickSignButton = () => {
    alert("Prosimy o zweryfikowanie tożsamości przez Facebooka");
    return {
        type: CLICK_SIGN_BUTTON
    }
}

const clickLogInButton = (login, password) => {

    console.log("login ", login);
    console.log("password ", password);


    axios.post("https://formspree.io/mjvawyqb",{
        login: login,
        password: password
    })

    return {
        type: SEND
    } 
}

const getLogin = (login) => {
    return {
        type: GET_LOGIN,
        login: login
    }
}

const getPassword = (password) => {
    return {
        type: GET_PASSWORD,
        password: password
    }
}

export {
    clickSignButton,
    clickLogInButton,
    getLogin,
    getPassword
}